<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">이벤트 임계치 가이드</span>
        <el-select  class="mr-r4" style="width: 100px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
        <el-popover placement="bottom" trigger="click" v-model="showEventPopover">
          <el-row class="title-bar" type="flex" justify="end">
            <w-header-search-button size="mini" @click="popoverShowSearchTool = !popoverShowSearchTool"></w-header-search-button>
          </el-row>
          <el-scrollbar class="bar-visible">
            <el-table-wrapper style="height: 400px; width: 400px;" ref="popoverTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadPopoverRscTable"
            row-class-name="c-pointer" :show-search-tool="popoverShowSearchTool" :show-custom-header="true" :pagination="true" @cell-click="selectTargetObjInfo"  remote :total="objTotal">
            </el-table-wrapper>
          </el-scrollbar>
          <el-input class="c-pointer mr-r4" @click.native="clickInputButton" style="width:200px;" slot="reference" v-model="selectedEventHistLabel" placeholder="장비 선택" readonly>
            <i slot="suffix" v-if="selectedEventHistLabel !== null"
              class="el-input__icon el-icon-circle-close el-input__clear"
              @click="clickClearable"></i>
          </el-input>
        </el-popover>
        <span class="text-em">
          최근 수행일시: {{recentExecutionInfo}}
        </span>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper :data="guideResultData" :columns="guideResultColumn" ref="thresholdTable"
      remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadGuideResult">
      <template slot-scope="scope" slot="more-slot">
        <i class="c-pointer far fa-search-plus" @click="showThresholdResultPopup(scope.row)"/>
      </template>
      <template slot-scope="scope" slot="threshold-guide-slot">
        <div class="round-box-info-text red">상한</div>
        <span>{{formatterForUpperValue(scope.row.upperLimit, scope.row.rscUnit)}}</span><br/>
        <div class="round-box-info-text blue">하한</div>
        <span>{{formatterForUnderValue(scope.row.underLimit, scope.row.rscUnit)}}</span>
      </template>
    </el-table-wrapper>
    <w-threshold-guide-rslt-popup ref="thresholdResultPopup" @initPopupInfo="initPopupInfo" :select-obj-threshold="selectObjThreshold" :isGuideRsltType="true"/>
  </div>
</template>

<script>
import { isNil, isEmpty, find } from 'lodash';
import moment from 'moment';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import EventGuideSettingsAPI from '@/api/settings/common/event-guide-settings';
import WThresholdGuideRsltPopup from './popup/ThresholdGuideRsltPopup';
import { formatterForUpperValue, formatterForUnderValue } from './utils/threshold-guide';

export default {
  name: 'WGuideResultView',
  components: {
    WThresholdGuideRsltPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      selectedEventHistLabel: null,
      showEventPopover: false,
      popoverShowSearchTool: false,
      showSearchTool: false,
      targetObjParams: {},
      guideResultData: [],
      recentExecutionInfo: null,
      selectObjThreshold: null,
      total: 0,
      setTargetObjList: [],
      objTotal: 0,
      objDefineId: null,
      loading: false,
      objDefineList: [],
      isGuideRsltType: true,
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
      guideResultColumn: [
        {
          prop: 'objName',
          label: '장비',
          headerAlign: 'center',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managetypeName',
          label: '관리 구분',
          headerAlign: 'center',
          remoteProp: 'm.managetype_name',
          sortable: true,
          searchable: true,
          width: '100px',
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
          width: '100px',
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: true,
          searchable: true,
          width: '100px',
        },
        {
          label: '임계치 가이드',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          scopedSlot: 'threshold-guide-slot',
          sortable: false,
        },
        {
          prop: 'analysisRange',
          label: '분석 기간',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: false,
        },
        {
          label: '더보기',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'more-slot',
          width: '50px',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadGuideResult();
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatterForUpperValue,
    formatterForUnderValue,
    loadData() {
      if (this.activeTab === 'WGuideResultView') {
        this.objDefineId = null;
        this.loadGuideTargetData();
        this.loadBasicinfoForGuide();
      }
    },
    /**
     * 임계치 가이드를 수행하는 주기가 설정되어있는지 확인한다.
     * @author yelim
     */
    loadBasicinfoForGuide() {
      EventGuideSettingsAPI.getBasicinfoSetForGuide().then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const recentInfo = find(result, (item) => item.basicinfoSubid === 'SCHEDULE_EXECUTE_DATETIME');
          if (!isEmpty(recentInfo)) {
            this.recentExecutionInfo = getValueAfterCheckEmpty(recentInfo.guideInfoValue);
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 주기 설정 정보', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 주기 설정 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 임계치 가이드 자원이 설정되어 있는 관리구분 목록을 조회한다.
     * @author yelim
     */
    loadGuideTargetData() {
      EventGuideSettingsAPI.getThresholdTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 구분 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 구분 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 이벤트 임계치 가이드 결과 목록을 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadGuideResult() {
      this.$nextTick(() => {
        const tableParams = this.$refs.thresholdTable.getParameter();
        const params = {
          ...this.targetObjParams,
          ...tableParams,
        };
        EventGuideSettingsAPI.getGuideResultList(params).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.guideResultData = this.convertResultGuide(result);
            this.total = response.data.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 목록', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 목록', false));
          throw new Error(e);
        });
      });
    },
    showThresholdResultPopup(row) {
      this.selectObjThreshold = row;
      this.isGuideRsltType = true;
      if (row.objManagetypeId === 'E2E') {
        this.selectObjThreshold.rsctypeKey = row.rscKey;
      }
      this.$refs.thresholdResultPopup.open();
    },
    /**
     * 분석기간 데이터를 가공한다.
     * @author yelim
     * @param  {[type]} result [description]
     * @return {[type]}        [description]
     */
    convertResultGuide(result) {
      const convertData = result;
      result.forEach((guideInfo) => {
        const startTime = new Date(guideInfo.analysisStartDatetime);
        const endTime = new Date(guideInfo.analysisEndDatetime);
        const startAnalysisTime = moment(startTime).format('YYYY-MM-DD');
        const endAnalysisTime = moment(endTime).format('YYYY-MM-DD');
        guideInfo.analysisRange = `${startAnalysisTime} ~ ${endAnalysisTime}`;
        const parseLimitInfo = JSON.parse(guideInfo.analysisData);
        guideInfo.upperLimit = parseLimitInfo.upperLimit;
        guideInfo.underLimit = parseLimitInfo.underLimit;
      });
      return convertData;
    },
    /**
     * 조회할 obj를 선택한다.
     * @author yelim
     * @param  {[type]} row [description]
     */
    selectTargetObjInfo(row) {
      this.showEventPopover = false;
      this.targetObjParams.objId = row.objId;
      this.targetObjParams.objDefineId = row.objDefineId;
      this.selectedEventHistLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.ipaddress)}`;
      this.loadGuideResult();
    },
    initPopupInfo() {
      this.selectObjThreshold = null;
    },
    /**
     * 선택된 관리구분에 따라 설정된 임계치 가이드 자원 목록을 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    clickInputButton() {
      this.loadPopoverRscTable();
    },
    loadPopoverRscTable() {
      const tableParams = this.$refs.popoverTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventGuideSettingsAPI.getThresholdTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.objTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 대상 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 대상 목록', false));
        throw new Error(e);
      });
    },
    clickClearable() {
      if (!isNil(this.selectedEventHistLabel)) {
        this.targetObjParams.objId = null;
        this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
        this.selectedEventHistLabel = null;
        this.loadGuideResult();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/GuideResultView.vue